import { Trans } from 'react-i18next';
import AdditionalInfo from '../AdditionalInfo';
import { ErrorMessage, FormTextField, LabeledComponent } from '../../index';
import './RowNumberInput.scss';

/**
 * Returns a component horizontal aligned with label, number input and a help icon
 * @param {{
 *  name: string,
 *  defaultValue: string,
 *  inputProps: {},
 *  label: string,
 *  control: *,
 *  disabled?: boolean,
 *  additionalInformation?: string
 *  validationError?: string
 * }} param0
 */
const RowNumberInput = ({
    label,
    control,
    disabled = false,
    additionalInformation = '',
    ...props
}) => {
    const { validationError, inputProps, ...rest } = props;

    const handleKeyDown = (e) => {
        if (e.key === '-' &&  inputProps?.min >= 0) {
            e.preventDefault();
        }
        inputProps?.onKeyDown?.(e);
    };

    return (
        <LabeledComponent name={label}>
            <FormTextField
                {...rest}
                label=""
                control={control}
                type="number"
                variant="outlined"
                disabled={disabled}
                inputProps={{
                    ...inputProps,
                    onKeyDown: handleKeyDown,
                }}
            />
            {additionalInformation && (
                <AdditionalInfo>
                    <Trans>
                        {additionalInformation}
                    </Trans>
                </AdditionalInfo>
            )}
            <ErrorMessage show={!!validationError?.message}>
                {validationError?.message}
            </ErrorMessage>
        </LabeledComponent>
    )
};

export default RowNumberInput;
